import axios, { AxiosResponse } from 'axios';
import CookieService from 'services/cookie';
import TokenService from 'services/token';

import { getBaseUrl } from './utils/getBaseUrl';
import { ErrorResponse, RefreshResponse, ResponseEnvelop } from '.';

const signInPath = '/api/v5/corporate-api/company-portal/auth/signin';
const refreshPath = '/api/v5/corporate-api/company-portal/auth/refresh';

const provider = (
  api_host: string,
  options?: { corporate_admin_api_host: string; geid: string }
) => {
  const { corporate_admin_api_host, geid } = options || {};
  const instance = axios.create({
    baseURL: `https://${api_host}`,
    headers: {
      'Content-Type': 'application/json',
      'X-FP-API-Key': 'corporate-company-admin',
      'X-Global-Entity-Id': geid || ''
    }
  });

  instance.interceptors.request.use((config) => {
    const token = TokenService.getToken();
    if (token) {
      config.headers = {
        ...config.headers
      };

      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  });

  instance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      // all path except sign in and refresh should be refresh
      if (
        originalConfig.url !== signInPath &&
        originalConfig.url !== refreshPath &&
        err.response
      ) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            const rs = await instance.post<ResponseEnvelop<RefreshResponse>>(
              refreshPath,
              {
                refresh_token: TokenService.getRefreshToken(),
                device_id: TokenService.getDeviceId()
              },
              {
                baseURL: getBaseUrl(api_host, corporate_admin_api_host)
              }
            );
            const { token, refresh_token, expires_in } = rs.data.data;
            TokenService.updateTokens(token, refresh_token);
            CookieService.setTokenCookie(token, expires_in);
            return instance(originalConfig);
          } catch (error) {
            if (axios.isAxiosError(error)) {
              if (error.response) {
                const axiosResponse =
                  error.response as AxiosResponse<ErrorResponse>;
                const res = axiosResponse.data;
                if (res.status_code === 401) {
                  CookieService.unsetTokenCookie();
                  TokenService.removeTokens();
                  // todo: temporary fix, should handle in error boundry
                  window.location.href = '/login';
                }
              }
            }

            return Promise.reject(error);
          }
        }
      }
      return Promise.reject(err);
    }
  );

  return instance;
};

export default provider;
